import { RouterModule } from '@angular/router';
import { ProjectComponent } from './project.component';
import { AuthGuard } from '../login/auth.guard';


// Deprecated
export const ProjectRouting = RouterModule.forChild([

{ path: 'main/project/:id', component: ProjectComponent, canActivate: [AuthGuard]},


]);
